import React, { useState } from 'react';
import { Checkbox, FormControlLabel, TextField, Typography } from '@mui/material';
import Container from './styles/Container';
import Wrapper from './styles/Wrapper';
import RowWrapper from './styles/RowWrapper';

type Props = {
  speedLimit: number | null;
  setSpeedLimit: (value: number | null) => void;
  stopTime: number | null;
  setStopTime: (value: number | null) => void;
};

function VehicleStopSpeedWidget({ speedLimit, setSpeedLimit, stopTime, setStopTime }: Props) {
  const [enableStopTime, setEnableStopTime] = useState(stopTime !== null);
  const [enableSpeedLimit, setEnableSpeedLimit] = useState(speedLimit !== null);

  const [localStopTime, setLocalStopTime] = useState(stopTime ?? 300);
  const [localSpeedLimit, setLocalSpeedLimit] = useState(speedLimit ?? 60);

  const handleStopTimeCheckbox = (checked: boolean) => {
    setEnableStopTime(checked);
    if (checked) {
      setStopTime(localStopTime);
    } else {
      setStopTime(null);
    }
  };

  const handleSpeedLimitCheckbox = (checked: boolean) => {
    setEnableSpeedLimit(checked);
    if (checked) {
      setSpeedLimit(localSpeedLimit);
    } else {
      setSpeedLimit(null);
    }
  };

  const handleStopTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    if (value < 1) return;

    setLocalStopTime(value);
    if (enableStopTime) setStopTime(value);
  };

  const handleSpeedLimitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    if (value < 1) return;

    setLocalSpeedLimit(value);
    if (enableSpeedLimit) setSpeedLimit(value);
  };

  return (
    <Container>
      <Wrapper>
        <FormControlLabel
          control={<Checkbox checked={enableStopTime} onChange={(e) => handleStopTimeCheckbox(e.target.checked)} />}
          label="Показ стоянок"
        />
        <RowWrapper>
          <TextField
            type="number"
            size="small"
            value={localStopTime}
            onChange={handleStopTimeChange}
            disabled={!enableStopTime}
            sx={{ width: 120 }}
            inputProps={{ min: 1 }}
          />
          <Typography>сек</Typography>
        </RowWrapper>
      </Wrapper>

      <Wrapper>
        <FormControlLabel
          control={<Checkbox checked={enableSpeedLimit} onChange={(e) => handleSpeedLimitCheckbox(e.target.checked)} />}
          label="Показ превышений скорости"
        />
        <RowWrapper>
          <TextField
            type="number"
            size="small"
            value={localSpeedLimit}
            onChange={handleSpeedLimitChange}
            disabled={!enableSpeedLimit}
            sx={{ width: 120 }}
            inputProps={{ min: 1 }}
          />
          <Typography>км/ч</Typography>
        </RowWrapper>
      </Wrapper>
    </Container>
  );
}

export default VehicleStopSpeedWidget;
